var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import { t } from '../../../infra/i18n';
var createInitialState = function (categories, initialValue) {
    return categories.reduce(function (memo, category) {
        var _a;
        return __assign(__assign({}, memo), (_a = {}, _a[category.id] = initialValue, _a));
    }, {});
};
var areAllSelected = function (categories, selection) {
    return categories.every(function (category) { return !!selection[category.id]; });
};
export var useCategoryFilter = function (
// mark as _categories to avoid it being used. the one with 'uncategorized' should be used instead
_categories, items) {
    var categories = __spreadArray([
        {
            id: 'uncategorized',
            name: t('common:categories.uncategorized'),
        }
    ], _categories, true);
    var _a = useState(createInitialState(categories, true)), selection = _a[0], setSelection = _a[1];
    var toggleSelectAll = function () {
        setSelection(function (currentState) {
            return createInitialState(categories, !areAllSelected(categories, currentState));
        });
    };
    var toggleCategory = function (categoryId) {
        setSelection(function (currentState) {
            var _a;
            return __assign(__assign({}, currentState), (_a = {}, _a[categoryId] = !currentState[categoryId], _a));
        });
    };
    var filteredItems = items.filter(function (item) {
        var hasCategory = item.categories.length > 0;
        if (!hasCategory && selection.uncategorized) {
            return true;
        }
        return item.categories.some(function (category) { return selection[category.id]; });
    });
    var selectedCategoriesCount = Object.values(selection).filter(Boolean).length;
    return {
        toggleSelectAll: toggleSelectAll,
        toggleCategory: toggleCategory,
        filteredItems: filteredItems,
        selectedCategoriesById: selection,
        allSelected: areAllSelected(categories, selection),
        categories: categories,
        selectedCategoriesCount: selectedCategoriesCount,
    };
};
